import renderer from 'global/react/renderer';

import './asset-tracking/index.css';
import '../../../components/code-explorer-react/code-explorer.css';

import Accordion from './asset-tracking/accordion';
import Animations from './asset-tracking/animations';
import CodeExamples from '../../../components/code-examples-react/CodeExamples';
import AssetTrackingDiagram from '../../../components/react/asset-tracking-diagram';

Animations();
Accordion(document.querySelector("[data-id='efficiency-accordion']"));

renderer({ AssetTrackingDiagram, CodeExamples });
